exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.boton[data-v-363c6509] {\n  background-color: #ffe800 !important;\n}\n", ""]);

// exports
